import { render, staticRenderFns } from "./SettingIcon.vue?vue&type=template&id=4c3b4cb2&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/packages/axiom-design-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c3b4cb2')) {
      api.createRecord('4c3b4cb2', component.options)
    } else {
      api.reload('4c3b4cb2', component.options)
    }
    module.hot.accept("./SettingIcon.vue?vue&type=template&id=4c3b4cb2&", function () {
      api.rerender('4c3b4cb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/04-web-components/powerbar/assets/icons/SettingIcon.vue"
export default component.exports